import { call, put, takeEvery } from "redux-saga/effects";
import { updateDocument } from "../../services/DocServerService";
import { getAuthToken, getClientId } from "./auth";
import { enqueueSnackbar } from "./notifiers";

// Actions
const SHOW_USER_DOCS = "hermes/docserver/SHOW_USER_DOCS";
const UPLOAD_LOCAL_DOC = "hermes/docserver/UPLOAD_LOCAL_DOC";
const REFRESHED = "hermes/docserver/REFRESHED";
const DOCUMENTS_MOVED_TO_PERM = "hermes/docserver/DOCUMENTS_MOVED_TO_PERM";
const ADD_TO_REFERRAL_SUCCESS = "hermes/docserver/ADD_TO_REFERRAL_SUCCESS";
const OPEN_SPLIT_DIALOG = "hermes/docserver/OPEN_SPLIT_DIALOG";
const OPEN_SPLIT_DIALOG_SUCCESS = "hermes/docserver/OPEN_SPLIT_DIALOG_SUCCESS";
const CLOSE_SPLIT_DIALOG = "hermes/docserver/CLOSE_SPLIT_DIALOG";
const UPDATE_DOCUMENT_META = "hermes/docserver/UPDATE_DOCUMENT_META";
const UPDATE_REFRESH_STATUS = "hermes/docserver/UPDATE_REFRESH_STATUS";
const UPDATE_REFRESH_DOCUMENT_TRIAGE_STATUS =
  "hermes/docserver/UPDATE_REFRESH_DOCUMENT_TRIAGE_STATUS";

export const initialState = {
  loaded: false,
  uploadMode: false,
  openSplitDialog: false,
  refreshNeeded: false,
  error: false,
  docs: [],
  refreshNewDocList: false,
  refreshDocumentTriage: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_USER_DOCS:
      return {
        ...state,
        uploadMode: false,
      };
    case UPLOAD_LOCAL_DOC:
      return {
        ...state,
        uploadMode: true,
      };
    case ADD_TO_REFERRAL_SUCCESS:
      return {
        ...state,
        refreshNeeded: true,
      };
    case REFRESHED:
      return {
        ...state,
        refreshNeeded: false,
      };
    case OPEN_SPLIT_DIALOG_SUCCESS:
      return {
        ...state,
        openSplitDialog: true,
      };
    case CLOSE_SPLIT_DIALOG:
      return {
        ...state,
        openSplitDialog: false,
      };
    case DOCUMENTS_MOVED_TO_PERM:
      return {
        ...state,
        docs: state.docs.filter(
          (stateDoc) =>
            !action.docList.find(
              (docListDoc) => docListDoc.uuid === stateDoc.uuid
            )
        ),
      };
    case UPDATE_REFRESH_STATUS:
      return {
        ...state,
        refreshNewDocList: action.refreshNewDocList,
      };
    case UPDATE_REFRESH_DOCUMENT_TRIAGE_STATUS:
      return {
        ...state,
        refreshDocumentTriage: action.refreshDocumentTriage,
      };
    default:
      return state;
  }
}

let lastFilters;
// Action Creators
export function getClientDocs(filters = lastFilters) {
  lastFilters = filters;
  return {
    type: SHOW_USER_DOCS,
    filters,
  };
}

export function removeDocumentsFromList(docList) {
  return {
    type: DOCUMENTS_MOVED_TO_PERM,
    docList,
  };
}

export function updateDocumentMeta(doc) {
  return {
    type: UPDATE_DOCUMENT_META,
    doc,
  };
}
export function openSplitDialog(pdfTronOpenFn) {
  return {
    type: OPEN_SPLIT_DIALOG,
    pdfTronOpenFn,
  };
}

export function closeSplitDialog(pdfTronOpenFn) {
  return {
    type: CLOSE_SPLIT_DIALOG,
    pdfTronOpenFn,
  };
}

export function refreshedDocList() {
  return {
    type: REFRESHED,
  };
}

export function newDocListShouldRefresh(shouldRefresh) {
  return {
    type: UPDATE_REFRESH_STATUS,
    refreshNewDocList: shouldRefresh,
  };
}

export function documentTriageShouldRefresh(shouldRefresh) {
  return {
    type: UPDATE_REFRESH_DOCUMENT_TRIAGE_STATUS,
    refreshDocumentTriage: shouldRefresh,
  };
}

export function addDocsToReferralSuccess() {
  return {
    type: ADD_TO_REFERRAL_SUCCESS,
  };
}

// Sagas

function* handleUpdateDocumentMeta({ doc }) {
  try {
    const authToken = yield call(getAuthToken);
    const clientId = yield call(getClientId);
    yield call(updateDocument, authToken, clientId, doc?.uuid, doc);
    yield put(getClientDocs());
    yield put(
      enqueueSnackbar({
        message: `Updated document ${doc?.filename}`,
        options: {
          variant: "success",
        },
      })
    );
  } catch (e) {
    console.log(e);
  }
}

/**
 * The executing function that handles the saga call to DocServerService
 * @param  {Object} action Object defined to access the documentList/document that needs to be uploaded
 */

function* handleOpenSplitDialog(action) {
  try {
    const shouldOpenSplitDialog = yield action.pdfTronOpenFn();
    if (shouldOpenSplitDialog) {
      yield put({ type: OPEN_SPLIT_DIALOG_SUCCESS });
    } else {
      yield put(
        enqueueSnackbar({
          message: `Please select the page(s) first by pressing ctrl-click for each page you would like to split out on the thumbnails view.`,
          options: {
            variant: "error",
          },
        })
      );
    }
  } catch (e) {
    // Should never occur.
    yield put(
      enqueueSnackbar({
        message: `An error occurred while attempting to split.`,
        options: {
          variant: "error",
        },
      })
    );
  }
}

export function* openSplitDialogSaga() {
  yield takeEvery(OPEN_SPLIT_DIALOG, handleOpenSplitDialog);
}

export function* handleUpdateDocumentMetaSaga() {
  yield takeEvery(UPDATE_DOCUMENT_META, handleUpdateDocumentMeta);
}
